export const URL = 'https://apib2b.auxo.com.pk';
export const SOCKET_URL = 'https://socketb2b.auxo.com.pk';
export const PRODUCTION = true;

// //   staging
// export const URL = 'https://apib2bstaging.auxo.com.pk';
// export const SOCKET_URL = 'https://socketb2bStaging.auxo.com.pk';
// export const PRODUCTION = false;

// export const URL = 'http://localhost:8080';
// export const SOCKET_URL = 'http://localhost:8080';
// export const PRODUCTION = false;

export const DVR_ACCOUNT = 'admin';
export const DVR_PASSWORD = 'Alquddoos@321'
export const MVDR_URL = 'https://telenormic.com';
export const apiV1 = '/api/v1';
export const apiV2 = '/api/v2';
export const userCredEncryptionKey = 'aUxO_3@4';
export const socketAuth = 'aUxO_3@4';

export const googleAnalytics = "UA-153479146-1";

// Company IDs with trikes/special UI (TRIKES nav, MSM/SPD labels, plate-number select, etc.)
export const TRIKES_SPECIAL_COMPANY_IDS = ["672c88ae37c7c36cba2b2fd2", "69aa7f2ff90eb976bf3d91d2"];

// Company IDs that can see and run Consolidated Trips Report (requires tripDetailReport permission)
export const CONSOLIDATED_TRIPS_REPORT_COMPANY_IDS = [
  "68d68c5f42b9381526c3f384",
  "694cf9647a61441506e59a1e",
  "69fc6fd6116ecc21611f65b3",
  "69fc2ce8facfbb2109634d2b",
  "6759740df8957048b4bd50ec",
  "6a6c591af78f7d067a43f9d7",
];
